/**
  @Time: 2023/08/25-11:36
 
  @File: api.js
  @Software: vscode
  @Description: API封装
*/
import http from './http'

//获取图片验证码
export function getCodeImg(params){
  return http.get('/mutenet/verify/code/img',params)
}


// 登录
export function loginApi(params) {
    return http.post('/mutenet/login', params);
}

//注册
export function registerApi(params) {
  return http.post('/mutenet/register', params);
}
///发送邮箱验证码
export function endEmail(params) {
  return http.post('/mutenet/verify/code/email?action=register', params);
}


//获取订阅地址
export function subscribeApi(params) {
  return http.get('/mutenet/user/subscribe/url', params);
}

//获取套餐 获取用户已经购买了的套餐 
export function getPackages(params) {
  return http.get('/mutenet/user/package/stat', params);
}

//获取全部套餐
export function getAllPackages(params){
  return http.get('/mutenet/packages', params);
}

//获取节点信息
export function serverApi(params) {
  return http.get('/mutenet/user/nodes', params);
}

//获取所有公告
export function getAllNotice(){
  return http.get('/mutenet/notice');
}

//获取所有订单
export function ordersApi(params) {
  return http.get('/mutenet/user/orders', params);
}
export function cancelOrder(params,url) {
  return http.put('/mutenet/user/orders'+url, params);
}
//用户创建订单
export function order(params){
  return http.post('/mutenet/user/order/create', params);
}
//用户支付
export function pay(params){
  return http.post1('/mutenet/user/order/checkout', params);
}

//获取支持的币种
///mutenet/payment/currencies
export function payment(params){
  return http.get('/mutenet/payment/currencies', params);
}
//获取所有的支付方式
export function getMethods(params){
  return http.get('/mutenet/payment/methods', params);
}

//用户修改密码
///mutenet/user/password
export function changePassword(params){
  return http.post('/mutenet/user/password', params);
}

//用户重置密码
export function resetPassword(params){
  return http.post('/mutenet/password/reset', params);
}
///发送邮箱验证码
export function endEmail_resetPassword(params) {
  return http.post('/mutenet/verify/code/email?action=reset_password', params);
}
//重置订阅链接 /mutenet/user/subscribe/url
export function resetURL(params){
  return http.put('/mutenet/user/subscribe/url', params);
}
